import BaseModel from './BaseModel'

export default class RoServiceOpCode extends BaseModel {
  // ... RoServiceOpCode-specific methods or overrides ...
}
